'use client';

import {
  Box,
  Button,
  CheckboxListItem,
  Typography,
} from '@wishket/design-system';

import { Link, Icon } from '@/shared/Components';
import { PATH } from '@/shared/constants';

interface OnBoardingStartFormProps {
  username: string;
  isChecked: boolean;
  isError: boolean;
  onChange: () => void;
  onNextStep: () => void;
}

const OnBoardingStartForm = ({
  username,
  isChecked,
  isError,
  onChange,
  onNextStep,
}: OnBoardingStartFormProps) => {
  return (
    <Box
      className="flex h-full w-full flex-col justify-between desktop:h-fit"
      data-testid="features-onBoardingStartForm"
    >
      <Box className="border-b px-5 py-6 desktop:px-8">
        <Box className="flex items-center gap-1">
          <Typography variant="subTitle2">{`${username}님, 안녕하세요!`}</Typography>
          <Icon name="heart_face" />
        </Box>
        <Typography variant="subTitle2">
          요즘IT와 함께 성장해 볼까요?
        </Typography>
      </Box>

      <Box className="flex h-full flex-col gap-6 px-5 py-6 desktop:px-8">
        <Box className="flex flex-col gap-4">
          <Box className="flex items-center gap-3 rounded-2xl bg-w-gray-10 p-4">
            <Box className="rounded-full bg-w-white p-3">
              <Icon name="fire" />
            </Box>
            <Typography variant="body1" className="text-w-gray-600">
              매일 새롭고 다양한 IT 콘텐츠를 볼 수 있어요.
            </Typography>
          </Box>
          <Box className="flex items-center gap-3 rounded-2xl bg-w-gray-10 p-4">
            <Box className="rounded-full bg-w-white p-3">
              <Icon name="rocket" />
            </Box>
            <Typography variant="body1" className="text-w-gray-600">
              전문적인 IT 콘텐츠로 성장에 도움이 되었어요.
            </Typography>
          </Box>
        </Box>
        <CheckboxListItem
          type="box"
          checked={isChecked}
          onChange={onChange}
          isError={isError}
        >
          <Typography variant="body1">
            <Link href={PATH.AUTH_TERMS_SERVICE} target="_blank">
              <span className="font-medium text-primary">요즘IT 이용약관</span>
            </Link>
            <Typography variant="body1">{' 및 '}</Typography>
            <Link href={PATH.AUTH_TERMS_PRIVACY} target="_blank">
              <span className="font-medium text-primary">
                개인정보 처리방침
              </span>
            </Link>
            에 동의해 주세요.
          </Typography>
        </CheckboxListItem>
      </Box>

      <Box className="border-t px-5 py-6 desktop:px-8">
        <Button variant="solid" className="w-full" onClick={onNextStep}>
          <Typography variant="body1">위시켓 통합회원으로 시작하기</Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default OnBoardingStartForm;
